import { API } from "../core/API";

const api = new API("/api/v1");

export const applicationService = {
    getAll: () => api.get("/applications"),
    create: (data) => api.put("/applications", data), // Using PUT for create as requested
    update: (id, data) => api.put(`/applications/${id}`, data),
    delete: (id) => api.delete(`/applications/${id}`)
};
